const utils = require('./utils')
module.exports = utils



/*****************
 ** WEBPACK FOOTER
 ** ./~/geocoder-geojson/utils/index.js
 ** module id = 138
 ** module chunks = 0
 **/